import React from 'react';

export const SwordsCircleIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="32" cy="32" r="28" fill="#E6D3A3" stroke="#6D4C41" strokeWidth="2" />
      <line x1="20" y1="44" x2="43" y2="21" stroke="#4E342E" strokeWidth="3" strokeLinecap="round" />
      <line x1="21" y1="21" x2="44" y2="44" stroke="#4E342E" strokeWidth="3" strokeLinecap="round" />
      <rect x="17" y="43" width="8" height="4" rx="1" fill="#8D6E63" transform="rotate(-45 17 43)" />
      <rect x="39" y="17" width="8" height="4" rx="1" fill="#8D6E63" transform="rotate(45 39 17)" />
      <circle cx="32" cy="32" r="2.5" fill="#6D4C41" />
    </svg>
  );
};
